import { useEffect, useState } from 'react'

import moment from 'moment-timezone'

import { useInterval } from '../../common/hooks/useInterval'
import { calculateTimeLeft } from '../utils'

export const useApptCountDown = () => {
  const [startsIn, setStartsIn] = useState<string>('')
  const [startTime, setStartTime] = useState<moment.Moment | null>(null)

  useEffect(() => {
    if (startTime) {
      setStartsIn(calculateTimeLeft({ startTime }))
    } else {
      setStartsIn('')
    }
  }, [startTime])

  useInterval(
    () => {
      startTime && setStartsIn(calculateTimeLeft({ startTime }))
    },
    startsIn === 'now' || !startTime ? null : 1000,
  )
  return { startsIn, setStartTime }
}
